import { auth } from "@/services";

(function (angular) {
  "use strict";

  angular.module("app").controller("adminNewsController", adminNewsController);

  adminNewsController.$inject = [
    "NewsApi",
    "News",
    "SettingsApi",
    "alerts",
    "handleError",
    "queryParams",
    "thisSiteSettings",
  ];

  function adminNewsController(
    NewsApi,
    News,
    SettingsApi,
    alerts,
    handleError,
    queryParams,
    thisSiteSettings,
  ) {
    var vm = this;

    // properties
    vm.permissionChecks = {
      canCreateNews:
        auth.hasPermission("news.create") ||
        auth.hasPermission("news.create-billable"),
      canManageSettings: auth.hasPermission("sites.set.settings"),
    };
    vm.posts = {};
    vm.isLoading = false;
    vm.page = 1;
    vm.sort = "created_at";
    vm.order = "desc";
    vm.filters = {
      status: "",
      title: "",
      page: 1,
      page_size: 15,
      with: "user",
    };
    vm.charge = {
      price: undefined,
      online: false,
    };
    vm.statusOptions = [
      { label: "All", value: "" },
      { label: "Pending", value: "pending" },
      { label: "Approved", value: "approved" },
      { label: "Rejected", value: "rejected" },
    ];
    vm.editedPendingPosts = []; // holds the ID's of pending posts, in case they're approved, so we can add a style
    vm.currencySymbol = thisSiteSettings.currency_symbol;

    // methods
    vm.getPosts = getPosts;
    vm.editPost = editPost;
    vm.createPost = createPost;

    vm.getNewsSettings = getNewsSettings;
    vm.setNewsSettings = setNewsSettings;

    /**
     * Retrieves settings from the API. Shame we can't specify an array of keys.
     * @return {void}
     */
    function getNewsSettings() {
      SettingsApi.get({}, (response) => {
        if (response && response.data) {
          vm.charge.price = response.data.news_charge_price;
          vm.charge.online = response.data.news_charge_accept_online_payments;
        }
      });
    }

    /**
     * Sets settings to the API.
     * @return {void}
     */
    function setNewsSettings() {
      SettingsApi.save(
        {
          settings: {
            news_charge_enabled: vm.charge.enabled,
            news_charge_price: vm.charge.price,
            news_charge_accept_online_payments: vm.charge.online,
          },
        },
        function (response) {
          if (response && response.data && response.data.news_charge_enabled) {
            vm.charge.enabled = response.data.news_charge_enabled;
            vm.charge.price = response.data.news_charge_price;
            vm.charge.online = response.data.news_charge_accept_online_payments;
          }

          alerts.emit({
            theme: "success",
            title: "Settings updated.",
          });
        },
      );
    }

    /**
     * Retrieves news posts from the api and adds to scope
     * @return {void}
     */
    function getPosts() {
      vm.isLoading = true;
      NewsApi.get(
        vm.filters,
        function (response) {
          vm.posts = response;
          vm.isLoading = false;
        },
        function () {
          vm.isLoading = false;
        },
      );
    }

    /**
     * Edits the post via a modal, and updates model in this controller
     * @param  {object} post - news post object containing id, status
     * @return {void}
     */
    function editPost(post) {
      if (post.status === "pending") {
        vm.editedPendingPosts.push(post.id);
      }

      News.manageNews(post.id).result.then(
        function (updatedPost) {
          // Find and update the news post on this page
          angular.forEach(vm.posts.data, function (post, index) {
            if (post.id === updatedPost.id) {
              if (
                vm.editedPendingPosts.indexOf(updatedPost.id) !== -1 &&
                updatedPost.status === "approved"
              ) {
                // this event has been changed from pending to approved
                updatedPost.recentlyApproved = true;
              }

              vm.posts.data[index] = updatedPost;
            }
          });
        },
        function (action) {
          if (action === "deleted") {
            getPosts();
          }
        },
      );
    }

    /**
     * Creates an event then refreshes posts
     * @return {void}
     */
    function createPost() {
      News.manageNews().result.then(function () {
        getPosts();
      });
    }

    // go!
    (function () {
      getPosts();
      getNewsSettings();

      // if ?create is set, show the create modal
      if (queryParams.create) {
        createPost();
      }

      // if ?edit=N is set, show the edit modal
      if (queryParams.edit) {
        editPost({ id: queryParams.edit });
      }
    })();
  }
})(angular);
